export default {"src":"/_next/static/media/check.ba5a01a4.svg","height":20,"width":20};